/**
 * 「这几单我已经看见了」。
 *
 * ★ 为什么需要它:开了「派单免确认」之后,新派的单直接进「待取货」,
 *   而原来那张待接单卡片(🔔 新任务)筛的是 ASSIGNED —— 它不再出现。
 *   于是新活只是**悄悄多一行**,司机盯着手机也未必发现。
 *   推送目前是空实现,所以这张卡是他唯一的信号。
 *
 * ★ 存在 localStorage 而不是服务端:这是「这台设备上这个人看没看过」,
 *   不是订单的属性。放到服务端就得多一张表、多一次写,
 *   而它对业务没有任何意义 —— 换台手机重新提示一次,完全可以接受。
 *
 * ★ 只留最近 200 条。不清的话这个键会一直涨,
 *   而司机的手机可能几个月不清缓存。
 */
const KEY = 'delivery.seenOrders';
const MAX = 200;

function read(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

export function seenSet(): Set<string> {
  return new Set(read());
}

export function markSeen(ids: string[]): void {
  if (ids.length === 0) return;
  // 新的排在后面,超出上限时从最老的开始丢
  const merged = [...read().filter((id) => !ids.includes(id)), ...ids];
  try {
    localStorage.setItem(KEY, JSON.stringify(merged.slice(-MAX)));
  } catch {
    /* 隐私模式下 localStorage 会抛 —— 不能因为这个让首页崩掉 */
  }
}
